import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import TopbarActions from '@/components/TopbarActions';

export default function Topbar() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-card border-b border-border h-14 flex items-center px-4 lg:px-8">
      <div className="flex items-center justify-between w-full max-w-screen-2xl mx-auto">
        <Link href="/" className="flex items-center gap-2 group">
          <AppLogo size={32} />
          <span className="font-bold text-lg tracking-tight text-foreground group-hover:text-primary transition-colors duration-150">
            ProveThemWrong
          </span>
        </Link>
        <TopbarActions />
      </div>
    </header>
  );
}